// Generated from Route's `required_filter_groups` — do not edit.

import type {FilterDefinitionMapping} from '../../boot/hooks/useApi'
import type {Iri} from '../Api'

export type RouteLiteCollectionFilterGroups
  = | {
    readonly sectorSpot: Iri | Iri[]
    readonly archived?: boolean | boolean[] | '*'
    readonly draft?: boolean | boolean[]
    readonly routeSet?: string | string[]
  }

export const routeLiteCollectionFilterMapping: FilterDefinitionMapping<RouteLiteCollectionFilterGroups> = {
  sectorSpot: 'sector.spot',
  archived: 'archived',
  draft: 'draft',
  routeSet: 'routeSet',
}

export type RouteLiteCollectionSort = 'color.name' | 'name' | 'grade' | 'sector.name' | 'lane.name' | 'setter.name' | 'settledAt'

export type RouteCollectionFilterGroups
  = | {
    readonly sectorSpot: Iri | Iri[]
    readonly archived?: boolean | boolean[] | '*'
    readonly draft?: boolean | boolean[]
    readonly routeSet?: string | string[]
  }

export const routeCollectionFilterMapping: FilterDefinitionMapping<RouteCollectionFilterGroups> = {
  sectorSpot: 'sector.spot',
  archived: 'archived',
  draft: 'draft',
  routeSet: 'routeSet',
}

export type RouteCollectionSort = 'color.name' | 'name' | 'grade' | 'sector.name' | 'lane.name' | 'setter.name' | 'settledAt'
